import { subscriptionsApi } from 'nove8/api'
import {
  COHORTS_PRESERVE_SUBSCRIPTIONS_ON_CREATE_COHORT_LEAD,
  Cohort,
  ProcessingKey,
} from 'nove8/constants/root-constants'
import { useZustandGlobalLocalStore } from 'zustandGlobalLocalStore'
import { useZustandStore } from 'zustandGlobalStore'
import { fetchGeoData } from './fetchGeoData'

export const createCohortLead = async (): Promise<void> => {
  useZustandStore.getState().startProcessing(ProcessingKey.CREATE_COHORT_LEAD)

  const initialCohort = useZustandStore.getState().initialCohort
  const leadId = useZustandStore.getState().lead?.id || ''

  const geoDataResponse = await fetchGeoData()

  const response = await subscriptionsApi.createCohortLead({
    cohort: initialCohort,
    geo: {
      city: geoDataResponse?.city || '',
      country: geoDataResponse?.country || '',
      region: geoDataResponse?.region || null,
      postalCode: geoDataResponse?.postalCode || null,
      ip: geoDataResponse?.ip || null,
      timezone: geoDataResponse?.timezone || null,
    },
    leadId,
  })

  if (response && response.data) {
    const lead = response.data

    useZustandGlobalLocalStore.setState((state) => ({
      previousLeadId: state.previousLeadId || lead.id,
    }))

    if (
      !COHORTS_PRESERVE_SUBSCRIPTIONS_ON_CREATE_COHORT_LEAD.includes(
        initialCohort as Cohort,
      )
    ) {
      useZustandStore.setState({ lead })
      useZustandStore
        .getState()
        .stopProcessing(ProcessingKey.CREATE_COHORT_LEAD)

      return
    }

    const currentLead = useZustandStore.getState().lead

    // we need to keep the lead info to start cohort flow and we need to rewrite the subscriptions info from fetchLead
    useZustandStore.setState({
      lead: {
        ...lead,
        purchases: currentLead?.purchases,
        subscriptions: currentLead?.subscriptions,
      },
    })
  }

  useZustandStore.getState().stopProcessing(ProcessingKey.CREATE_COHORT_LEAD)
}
